module.exports = __webpack_public_path__ + "static/img/party_council_test.9eb7c7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/party/party_council_test.png
// module id = BLrf
// module chunks = 0